import { render, staticRenderFns } from "./InfoBuy.vue?vue&type=template&id=26d4e73c&scoped=true&"
import script from "./InfoBuy.vue?vue&type=script&lang=js&"
export * from "./InfoBuy.vue?vue&type=script&lang=js&"
import style0 from "./InfoBuy.vue?vue&type=style&index=0&id=26d4e73c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d4e73c",
  null
  
)

export default component.exports